import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { openProductDetailModal } from '../../../../../../../../../store/products/products.actions';
import { useAdvancedShippingNoticeContext } from '../../../../advanced-shipping-notice-context';

import { messages } from '../messages';
import styles from '../select-products-table.module.less';

const SkuCell = ({ row }) => {
  const { validationErrors } = useAdvancedShippingNoticeContext();
  const { sku, productId } = row.original || {};
  const hasProductErrors = validationErrors?.selectedProducts?.length > 0 && validationErrors.selectedProducts[row.index];

  const dispatch = useDispatch();
  const onClick = useCallback(() => dispatch(openProductDetailModal(productId)), [dispatch, productId]);

  return (
    <>
      <Button onClick={onClick} theme='link'>
        {sku}
      </Button>
      {hasProductErrors && <FontAwesomeIcon className={styles['product-error-icon']} icon={faExclamationCircle} />}
    </>
  );
};

export const createSkuColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'sku',
  Header: <FormattedMessage {...messages.skuColumnHeader} />,
  Cell: SkuCell,
  width: 1,
});
